import * as React from "react";
import Link from "next/link";
import { portalRoutes } from "@nju/routes";
import { A, Button } from "@nju/ui";
import { IBannerState } from "./types";

interface IButtonsProps {
  userId: string | undefined;
  bannerState: IBannerState;
  refreshCallback: () => void;
  deleteOrchestrator?: () => void;
}

export function Buttons({
  userId,
  bannerState,
  refreshCallback,
  deleteOrchestrator,
}: IButtonsProps) {
  const handleOnPress = React.useCallback(() => {
    deleteOrchestrator?.();
    refreshCallback();
  }, [deleteOrchestrator, refreshCallback]);

  if (bannerState === "completeReplacementQRCode") {
    return (
      <div className="flex only-mobile:flex-col">
        <Link
          href={portalRoutes.mojeKonto.mojaKarta.wymianaKarty.esim.kartaGotowa.get(
            {
              ...(userId && { userId }),
            },
          )}
          passHref={true}
        >
          <A
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
          >
            wygeneruj QR kod
          </A>
        </Link>
      </div>
    );
  }

  if (
    bannerState === "cardChangedInProgress" ||
    bannerState === "orderPendingCancellation"
  ) {
    return (
      <div className="flex only-mobile:flex-col">
        <Button
          data-cy="refresh-button"
          onPress={refreshCallback}
          size={{
            "@onlyMobile": "s",
          }}
        >
          odśwież
        </Button>
      </div>
    );
  }

  if (bannerState === "completeReplacementAndActivatedCard") {
    return (
      <div className="flex only-mobile:flex-col">
        <Link
          href={portalRoutes.mojeKonto.mojaKarta.wymianaKarty.sim.dodajKarte.get(
            {
              ...(userId && { userId }),
            },
          )}
          passHref={true}
        >
          <A
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
          >
            dodaj i aktywuj kartę SIM
          </A>
        </Link>
      </div>
    );
  }

  if (
    bannerState === "cardSimChangedCompleted" ||
    bannerState === "cardEsimChangedCompleted"
  ) {
    return (
      <div className="flex only-mobile:flex-col">
        <Button
          onPress={handleOnPress}
          size={{
            "@onlyMobile": "s",
          }}
        >
          ok
        </Button>
      </div>
    );
  }

  // eslint-disable-next-line unicorn/no-null
  return null;
}
